// ============================================================
// Shared landing-page animations.
//
// Hooked in once from App.js after render. Uses IntersectionObserver
// and passive scroll listeners — no deps. Every function is a no-op
// when the target elements don't exist, so it's safe to re-run
// after client-side route dispatch (legal/explainer/signup routers).
// ============================================================

// --- B1/B2: scroll-triggered step reveals with number fill ---
export function initStepReveals() {
  const steps = document.querySelectorAll('.step');
  if (!steps.length) return;

  // Set initial hidden state only on steps not already revealed
  // (don't thrash on re-init).
  steps.forEach((step) => {
    if (step.dataset.reveal === 'init') return;
    step.dataset.reveal = 'init';
    const num = step.querySelector('.step-num');
    const title = step.querySelector('.step-title');
    const desc = step.querySelector('.step-desc');
    [step, num, title, desc].forEach((el) => {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity 0.45s ease, transform 0.45s ease';
    });
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const step = entry.target;
        const num = step.querySelector('.step-num');
        const title = step.querySelector('.step-title');
        const desc = step.querySelector('.step-desc');

        requestAnimationFrame(() => {
          step.style.opacity = '1';
          step.style.transform = 'none';
          if (num) {
            num.style.opacity = '1';
            num.style.transform = 'none';
            num.classList.add('revealed'); // triggers B2 fill
          }
        });
        setTimeout(() => {
          if (title) { title.style.opacity = '1'; title.style.transform = 'none'; }
        }, 80);
        setTimeout(() => {
          if (desc) { desc.style.opacity = '1'; desc.style.transform = 'none'; }
        }, 160);

        io.unobserve(step);
      });
    },
    { threshold: 0.15 },
  );
  steps.forEach((step) => io.observe(step));
}

// --- B7: hero headline parallax (desktop only) ---
export function initHeroParallax() {
  const headline = document.querySelector('.hero-headline');
  if (!headline) return;
  if (window.matchMedia('(max-width: 820px)').matches) return;

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    requestAnimationFrame(() => {
      headline.style.transform = `translateY(${window.scrollY * -0.08}px)`;
      ticking = false;
    });
    ticking = true;
  };
  window.addEventListener('scroll', onScroll, { passive: true });
}

export function initAll() {
  initStepReveals();
  initHeroParallax();
}
